import React from 'react';
import {reach} from '@hapi/hoek';
import HomePageContainer from '../../containers/HomePageContainer/HomePageContainer';
import CategoryContainer from '../../containers/CategoryContainer/CategoryContainer';
import ArticleContainer from '../../containers/ArticleContainer/ArticleContainer';
import {categoryLookup, getAncestorCategory} from '../../utils/utils';
const ARTICLE_SLUG = /\/(\w|-)+$/;

const Page = (props) => {
    const {slug, allCategories, homeId, children, ...rest} = props;
    const pageSlug = `/${slug}`;
    let category;
    let ancestorCategory;
    let partitionProps = {};
    let categoryId = null;

    if (pageSlug === '/') {
        return (
            <main className="main-wrapper">
                {children(partitionProps)}
                <HomePageContainer key="home" homeId={homeId} {...rest} />
            </main>
        );
    }

    category = categoryLookup(allCategories, 'path', pageSlug);

    if (category) {
        ancestorCategory = getAncestorCategory(category, allCategories, homeId);
        partitionProps.id = reach(ancestorCategory, 'sys.id');
        partitionProps.partition = category.partition;

        return (
            <main className="main-wrapper">
                {children(partitionProps)}
                <CategoryContainer
                    key="category"
                    categoryId={category.sys.id}
                    {...props}
                />
            </main>
        );
    }

    const parentSlug = pageSlug.replace(ARTICLE_SLUG, '');
    category = categoryLookup(allCategories, 'path', parentSlug);

    if (category) {
        ancestorCategory = getAncestorCategory(category, allCategories, homeId);
        categoryId = reach(category, 'sys.id');
        partitionProps.id = reach(ancestorCategory, 'sys.id');
        partitionProps.partition = category.partition;
    }

    return (
        <main className="main-wrapper">
            {children(partitionProps)}
            <ArticleContainer categoryId={categoryId} {...props} />
        </main>
    );
};

export default Page;
